import type { FaireProductEntity } from "../../entity_types/product";

export const starter_collection_52: FaireProductEntity = {
  token: "starter_collection_52",
  type: "product",
  name: "Ghia Aperitif",
  brandName: "Ghia",
  imageUrl: "",
  priceDollars: 33,
  msrpDollars: 66,
  description: "Migrated starter collections product",
  tags: ["starter-collections"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "playground-data-migration",
  },
};
